module.exports = __webpack_public_path__ + "static/media/menu-white.8e389ffa.svg";